import React, { useState } from "react";
import styled from "styled-components";
import { Button } from "../../Theme/Hyper";
import Input from "../UI/Form/Input";
const Main = styled.div`
  display: flex;
  flex-direction: column;
`;
const Stats = styled.div`
  display: flex;
  flex-direction: column;
  border-top: 1px solid #f2f2f2;

  margin-top: 1em;
  padding-top: 1em;
  max-height: 250px;
`;
const Entry = styled.div`
  display: flex;
  align-items: center;
`;
const List = styled.div`
  display: flex;
  height: 293px;
  overflow-y: auto;
`;
const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;
  > tbody > tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, 0.05);
  }
  th:nth-child(1) {
    width: 65px;
  }
  th:nth-child(3) {
    width: 100px;
  }
  th {
    padding: 10px;
    border-top: 1px solid #dee2e6;
  }
  td {
    padding-left: 10px;
    padding-right: 10px;
    border-top: 1px solid #dee2e6;
    width: ${(props) => props.width};
    padding: 4px;
    padding-left: 10px;
    padding-right: 10px;
    border-top: 1px solid #dee2e6;
    white-space: nowrap;
    overflow: hidden;
    font-size: 0.8em;
  }
  > tbody > tr:hover {
    background-color: #14ec8e;
    color: white;
    cursor: pointer;
    > td > div {
      color: #ea1047;
    }
  }
`;

const TH = styled.th`
  border-top: 0;
  border-bottom: 0;
  font-weight: 800;
  font-size: 0.8em;
  text-transform: uppercase;
  color: #343a40;
  text-align: left;
`;
export default function Corners({ player, onUpdate }) {
  const [update, setUpdate] = useState(false);
  const [newCorner, setNewCorner] = useState("");

  if (!player?.player?.corner) {
    player.player.corner = [];
  }

  return (
    <Main>
      <Stats>
        <Entry>
          <Input
            title={
              "Cornerman Name "
            }
            placeholder=""
            value={newCorner}
            onChange={(e) => {
              if (e.target.value.length <= 55) {
                setNewCorner(e.target.value);
              }
            }}
            onKeyDown={(e) => {
              if (e.keyCode === 13 && e.target.value !== "") {
                if (!player.player.corner) {
                  player.player.corner = [];
                }
                player.player.corner.push({
                  number:
                    player.player.corner.filter((s) => s.type === "stat")
                      .length + 1,
                  corner: newCorner,
                  type: "stat",
                });
                setNewCorner("");
                onUpdate(player);
                setUpdate(!update);
              }
            }}
          />
          {newCorner !== "" && (
            <Button
              style={{ marginTop: "18px" }}
              onClick={() => {
                if (!player.player.corner) {
                  player.player.corner = [];
                }
                player.player.corner.push({
                  number:
                    player.player.corner.filter((s) => s.type === "stat")
                      .length + 1,
                  corner: newCorner,
                  type: "stat",
                });
                setNewCorner("");
                onUpdate(player);
                setUpdate(!update);
              }}
            >
              Add Corner
            </Button>
          )}
        </Entry>
        <List>
          <Table>
            <thead>
              <tr>
                <TH>#</TH>
                <TH>Corner</TH>
                <TH></TH>
              </tr>
            </thead>
            <tbody>
              {player.player.corner &&
                player.player.corner
                  .filter((s) => s.type === "stat")
                  .map((corner, index) => {
                    return (
                      <tr>
                        <td>{index + 1}</td>
                        <td>
                          <Input
                            title={((corner && corner.corner.length) || 0) + "/55"}
                            value={corner.corner}
                            onChange={(e) => {
                              if (e.target.value.length <= 55) {
                                corner.corner = e.target.value;
                                onUpdate(player);
                                setUpdate(!update);
                              }
                            }}
                          />
                        </td>
                        <td>
                          <Button
                            onClick={() => {
                              player.player.corner =
                                player.player.corner.filter(
                                  (s) => s !== corner
                                );
                              onUpdate(player);
                              setUpdate(!update);
                            }}
                          >
                            Delete
                          </Button>
                        </td>
                      </tr>
                    );
                  })}
            </tbody>
          </Table>
        </List>
      </Stats>
    </Main>
  );
}
